import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { Box, Button } from '@mui/material';
import { Done as DoneIcon, Close as CloseIcon } from '@mui/icons-material';
import RescueMobileCard from '../../pages/Rescue/RescueMobileCard';
import { isRescueClaimed } from '../../helpers/RescuesHelper';
import ReleaseRescueButtons from './ReleaseRescueButtons';

const RecentRescue = ({
  rescue,
  onClick,
  noShadow = false,
  currentSlide = 0,
  maxSlides = 0,
  isRescueSlider = false,
  handleSliderNext = () => {},
  handleSliderPrev = () => {},
  isReceiverView = false,
  isDonorView = false,
  claimer = {},
  rescueSliderRef = {},
}) => {
  const { formatMessage } = useIntl();

  const isCancelled = rescue.cancelled_by_id !== null;
  const isClosed = rescue.closed_by_id !== null;
  const rescueDateTime = moment(`${rescue.date} ${rescue.pickup_begin}`, 'YYYYMMDD HH:mm:ss');
  const isRescuePast = moment().isSameOrAfter(rescueDateTime, 'second');

  return (
    <RescueMobileCard
      rescue={rescue}
      onClick={onClick}
      highlighted={rescue.closed_by_id === null}
      isCancelled={isCancelled}
      isClosed={isClosed}
      noShadow={noShadow}
      currentSlide={currentSlide}
      isRescueSlider={isRescueSlider}
      handleSliderNext={handleSliderNext}
      handleSliderPrev={handleSliderPrev}
      maxSlides={maxSlides}
      claimer={claimer}
      isReceiverView={isReceiverView}
      isDonorView={isDonorView}
      hideDonorLink={isReceiverView || isDonorView}
      hideExpandPanel={isReceiverView || isDonorView}
      rescueSliderRef={rescueSliderRef}
    >
      {!isCancelled && isRescueClaimed(rescue) && !isClosed && !isReceiverView && !isDonorView && (
        <Box display="grid" gap={1} data-introid="close-rescue-buttons">
          <Button
            startIcon={<DoneIcon />}
            size="large"
            color="primary"
            variant="contained"
            component={RouterLink}
            to={`/rescue/close/${rescue.id}`}
          >
            {formatMessage({ id: 'rescuer-dashboard-mobile.buttons.i-did-it' })}
          </Button>

          {isRescuePast && (
            <Button
              startIcon={<CloseIcon />}
              size="large"
              color="primary"
              variant="outlined"
              component={RouterLink}
              to={`/rescue/close/noshow/${rescue.id}`}
            >
              {formatMessage({ id: 'rescuer-dashboard-mobile.buttons.i-could-not-make-it' })}
            </Button>
          )}

          {!isRescuePast && <ReleaseRescueButtons rescue={rescue} buttonVariant="outlined" />}
        </Box>
      )}
    </RescueMobileCard>
  );
};

export default RecentRescue;
